const DEFAULT_BASE_URL = "https://www.actipace.com/api/v1";
const BASE_URL = typeof window !== "undefined" && window.location?.origin
    ? `/api/v1`
    : DEFAULT_BASE_URL


//

export const categories = {
    OTPSENDER_API : BASE_URL + "/otpsender",
    SIGNUP_API : BASE_URL + "/signup",
    OTPLOGIN_API : BASE_URL + "/otplogin",
    LOGIN_API : BASE_URL + "/login",
    LOGOUT_API : BASE_URL + "/logout",
    RESETPASSWORDTOKEN_API : BASE_URL + "/resetPasswordToken",
    RESETPASSWORD_API : BASE_URL + "/resetPassword",
    CAPTUREPAYMENT_API : BASE_URL + "/capturePayment",
    VERIFYSIGNATURE_API : BASE_URL + "/verifySignature",
    GETPLAN_API : BASE_URL + "/getplan",
    CHECKPLAN:BASE_URL + "/checkplan",
    CONTACT:BASE_URL + "/contact",
    SUPPORT:BASE_URL + "/support",
    DASHBOARD:BASE_URL + "/dashboard",
    PAYPAL_CREATE_ORDER_API:BASE_URL +  "/create-order",
    PAYPAL_CAPTURE_ORDER_API:BASE_URL +  "/verify",
    CONFIG_API: BASE_URL + "/config",
    COUPON_VALIDATE_API: BASE_URL + "/coupon/validate"
}
